import VueTypes, { nullable } from 'vue-types';

// MODEL: UnitItem
export const UnitItem = VueTypes.shape({
    unit: VueTypes.string.isRequired,
    value: VueTypes.number.isRequired,
}).isRequired

// MODEL: ReviewItem
export const UserReviewItem = VueTypes.shape({
    id: VueTypes.number.isRequired,
    name: VueTypes.string.isRequired,
    text: VueTypes.string.isRequired,
    rate: VueTypes.number.isRequired,
    date: VueTypes.string.isRequired,
    likes: VueTypes.number.isRequired,
    dislikes: VueTypes.number.isRequired,
}).isRequired

export const createUnitItem = ({
    unit, value,
}) => {
    return {
        unit: unit,
        value: value,
    }
}

export const createUserReviewItem = ({
    id, name, text, rate,
    date, likes, dislikes
}) => {
    return {
        id: id,
        name: name,
        text: text,
        rate: rate,
        date: date,
        likes: likes,
        dislikes: dislikes,
    }
}